import { MenuItemFn } from './menu-item';
import ColorSelector from '@/components/editor/toolbar/sections/ColorSelector.vue';

export const columnCommands: MenuItemFn = ({ editor, translate }) => [
  {
    icon: 'add-column-before',
    effect: () => (editor.chain().focus() as any).addColumnBefore().run(),
    tooltip: translate('menu.add-column-before'),
  },
  {
    icon: 'add-column-after',
    effect: () => (editor.chain().focus() as any).addColumnAfter().run(),
    tooltip: translate('menu.add-column-after'),
  },
];

export const rowCommands: MenuItemFn = ({ editor, translate }) => [
  {
    icon: 'add-row-before',
    effect: () => (editor.chain().focus() as any).addRowBefore().run(),
    tooltip: translate('menu.add-row-before'),
  },
  {
    icon: 'add-row-after',
    effect: () => (editor.chain().focus() as any).addRowAfter().run(),
    tooltip: translate('menu.add-row-after'),
  },
];

export const mergeCommands: MenuItemFn = ({ editor, translate }) => [
  {
    icon: 'merge-cells',
    effect: () => (editor.chain().focus() as any).mergeOrSplit().run(),
    tooltip: translate('menu.merge-cells'),
    disabled: () => editor.disabledButtonStates.mergeCells,
  },
  {
    icon: 'header-row-2',
    effect: () => (editor.chain().focus() as any).toggleHeaderCell().run(),
    tooltip: translate('menu.toggle-header-row'),
  },
  {
    icon: 'color',
    effect: () => {},
    tooltip: translate('menu.table-cell-color'),
    customButton: ColorSelector as any,
  },
];

export const deleteCommands: MenuItemFn = ({ editor, translate }) => [
  {
    icon: 'delete-column',
    effect: () => (editor.chain().focus() as any).deleteColumn().run(),
    tooltip: translate('menu.delete-column'),
  },
  {
    icon: 'delete-row',
    effect: () => (editor.chain().focus() as any).deleteRow().run(),
    tooltip: translate('menu.delete-row'),
  },
  {
    icon: 'trash',
    effect: () => (editor.chain().focus() as any).deleteTable().run(),
    tooltip: translate('menu.delete-table'),
  },
];

export const controlCommands: MenuItemFn = ({ editor, translate }) => [
  {
    icon: 'expand-horizontal',
    effect: () => (editor.chain().focus() as any).toggleTableContentWidth().run(),
    tooltip: translate('menu.toggle-expand-to-page-size'),
  },
];

export const tableCommands = [
  columnCommands,
  rowCommands,
  mergeCommands,
  deleteCommands,
  controlCommands,
];
